export default "__VITE_ASSET__c85809b9__"